import React, { useState } from "react";
import Select from "react-select";

const CustomDropdownIndicator = ({ selectProps }) => {
  const { Icon } = selectProps;
  return (
    <div className="flex items-center justify-center">
      {Icon ? <Icon className="w-5 h-5" /> : null}
    </div>
  );
};

const customStyles = {
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  
};

const DropdownWithIconInBoundary = ({ Icon, options, onChange, value,isDisabled=false }) => {
  const [selectedOption, setSelectedOption] = useState(value || null);

  const handleChange = (selectedOption) => {
   
    setSelectedOption(selectedOption?.value);
    if (onChange) {
      onChange(selectedOption?.value); 
    }
  };

  return (
    <div title={selectedOption ? options.find((option) => option?.value === selectedOption)?.label : ""}>
    <Select
      options={options}
      value={options.find((option) => option.value === selectedOption)}
      onChange={handleChange}
      components={{ DropdownIndicator: CustomDropdownIndicator }}
      className="w-full"
      classNamePrefix="react-select"
      Icon={Icon}
      styles={customStyles}
      menuPortalTarget={document.body}
      isDisabled={isDisabled}
    />
    </div>
  );
};

export default DropdownWithIconInBoundary;
